export const strategyPrivateRoutesConstants = {
  root: {
    path: "/r/app/strategy",
    href: () => `/r/app/strategy`
  },
  exec_dashboard: {
    path: "/r/app/strategy/dashboard",
    href: () => `/r/app/strategy/dashboard`
  },
  exec_reports: {
    path: "/r/app/strategy/reports",
    href: () => `/r/app/strategy/reports`
  },
  objectives: {
    path: "/r/app/strategy/objectives",
    href: (projectId = "all") =>
      `/r/app/strategy/objectives?project=${projectId}`
  },
  single_objective: {
    path: "/r/app/strategy/objectives/:objectiveId",
    href: (objectiveId: string, projectId = "all") =>
      `/r/app/strategy/objectives/${objectiveId}?project=${projectId}`
  },
  decisions: {
    path: "/r/app/strategy/decisions",
    href: () => `/r/app/strategy/decisions`
  },
  single_decision: {
    path: "/r/app/strategy/decisions/:decisionId",
    href: (decisionId: number) => `/r/app/strategy/decisions/${decisionId}`
  },
  decision_statuses: {
    path: "/r/app/strategy/decisions/statuses",
    href: () => `/r/app/strategy/decisions/statuses`
  }
} as const;
